import { createRoute } from "@tanstack/react-router";

import { teamRoute } from "../../platform/routes";
import { ProfileScreen } from "./ProfileScreen";

/**
 * The Account page's first tab, Profile, under the URL's team (spec web/account-settings,
 * decision 1). Every other tab is a route of its own at `account/<tab>` (spec web/account-tabs).
 */
export const accountRoute = createRoute({
  getParentRoute: () => teamRoute,
  path: "account",
  component: ProfileScreen,
});
